"use client";
import { LoadingButton } from "@mui/lab";
import { useTheme } from "@mui/material/styles";

/**
 *
 * @param {import("@mui/lab").LoadingButtonProps} props
 * @returns {Button}
 */
const PlainLoadingButton = ({ children, ...props }) => {
  /**
   * @type {import("../themeing").CustomThemeProps}
   */
  const theme = useTheme();

  const [textColor, bgColor, hoverColor, lightBgColor] =
    theme.customProps.colorMode === "dark"
      ? ["black", "white", "#e7e7e7", "rgba(255,255,255,0.1)"]
      : ["white", "black", "#222", "rgba(0,0,0,0.4)"];

  const fixProps = (props) => {
    const obj = {};
    Object.assign(obj, props);
    switch (props?.variant) {
      case "contained":
        obj.sx = {
          bgcolor: bgColor,
          color: textColor,
          "&:hover": {
            bgcolor: hoverColor,
          },
          ".MuiTouchRipple-rippleVisible": {
            color: `${textColor}`,
          },
          ...obj?.sx,
        };
        break;
      case "outlined":
        obj.sx = {
          color: bgColor,
          borderColor: bgColor,
          "&:hover": {
            bgcolor: lightBgColor,
            borderColor: hoverColor,
          },
          ".MuiTouchRipple-rippleVisible": {
            color: `${bgColor}`,
          },
          ...obj?.sx,
        };
        break;
      default:
        obj.sx = {
          color: bgColor,
          "&:hover": {
            bgcolor: lightBgColor,
          },
          ".MuiTouchRipple-rippleVisible": {
            color: `${bgColor} !important`,
          },
          ...obj?.sx,
        };
      // by default text !
    }
    return obj;
  };
  return (
    <>
      <LoadingButton {...fixProps(props)}>{children}</LoadingButton>
    </>
  );
};

export default PlainLoadingButton;
